import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import type {
  ResearchCustomerInteractionsToolInput,
  ResearchCustomerInteractionsToolOutput,
} from "@repo/app-types/agents/researchCustomerInteractionsTool";
import { renderPlural } from "@repo/app-types/helpers/utilities";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const ResearchCustomerInteractionsTool: ToolComponent<
  ResearchCustomerInteractionsToolInput,
  ResearchCustomerInteractionsToolOutput | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Reviewing customer interactions...";
    }

    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while reviewing customer interactions";
    }

    const summary = renderPlural(props.output.counts.sample, {
      zero: "No customer interactions reviewed",
      one: "Reviewed 1 customer interaction",
      // TODO: props.input contains raw LLM tool call args (before Zod transforms),
      // so sample can be null even though the schema transforms it to a default.
      // Revisit after upgrading Mastra — newer versions may apply transforms before
      // passing args to the UI component.
      other: (count) =>
        (props.input.sample?.type ?? "most_recent") === "most_recent"
          ? `Reviewed ${count.toLocaleString()} recent customer interactions`
          : `Reviewed a sample of ${count.toLocaleString()} customer interactions`,
    });
    // This tool has no expandable details view, so name the playbook inline
    // (only present when the agent is scoped to several playbooks).
    return props.output.playbook
      ? `${summary} · ${props.output.playbook.name}`
      : summary;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
